import { call, put, takeLatest, select } from 'redux-saga/effects';

import { types } from '../constants';
import * as usersApi from '../api/users';
import { submitMode } from '../constants';
import { showMessage } from '../actions';

function* getLoggedInUserId() {
  const extractLoggedInUserId = (state) => state.users.user.item;

  const loggedInUser = yield select(extractLoggedInUserId);
  const loggedInUserId = loggedInUser && loggedInUser.id;
  return loggedInUserId;
}

function* watchFetchUserPermissions({ userEmail }) {
  try {
    yield put({ type: types.START_FETCH_USER_DETAILS });
    const { jsonData } = yield call(usersApi.fetchUserPermissions, userEmail);
    yield put({ type: types.FETCH_USER_DETAILS_SUCCESS, user: jsonData });
  } catch (e) {
    yield resolveError(types.FETCH_USER_DETAILS_FAILURE, e);
  } finally {
    yield put({ type: types.FETCH_USER_DETAILS_FINISHED });
  }
}

function* watchSendChnagePasswordRequest({ userEmail }) {
  try {
    const loggedInUserId = yield getLoggedInUserId();
    yield put({ type: types.START_SEND_CHANGE_PASSWORD_REQUEST });
    yield call(usersApi.changePassword, userEmail, loggedInUserId);
    yield put({ type: types.SEND_CHANGE_PASSWORD_REQUEST_SUCCESS });
  } catch (e) {
    yield resolveError(types.SEND_CHANGE_PASSWORD_REQUEST_FAILURE, e);
  } finally {
    yield put(
      showMessage(`A password change email has been sent to ${userEmail}.`)
    );
    yield put({ type: types.SEND_CHANGE_PASSWORD_REQUEST_FINISHED });
    yield put({ type: types.OPEN_CHANGE_PASSWORD_DIALOG, open: false });
  }
}

function* watchFetchAllUsers() {
  try {
    const loggedInUserId = yield getLoggedInUserId();
    yield put({ type: types.START_FETCH_ALL_USERS });
    const { jsonData } = yield call(usersApi.getAllUsers, loggedInUserId);
    yield put({
      type: types.FETCH_ALL_USERS_SUCCESS,
      allUsers: jsonData
    });
  } catch (e) {
    yield resolveError(types.FETCH_ALL_USERS_FAILURE, e);
  } finally {
    yield put({ type: types.FETCH_ALL_USERS_FINISHED });
  }
}

function* watchSubmitUser({ user, mode }) {
  try {
    const loggedInUserId = yield getLoggedInUserId();
    yield put({ type: types.START_SUBMIT_USER });
    const { jsonData } =
      mode === submitMode.CREATE
        ? yield call(usersApi.createUser, user, loggedInUserId)
        : yield call(usersApi.editUser, user, loggedInUserId);

    yield put({
      type: types.SUBMIT_USER_SUCCESS,
      submittedUser: jsonData
    });

    if (mode === submitMode.CREATE) {
      yield put({ type: types.OPEN_CREATE_USER_DIALOG, open: false });
    } else {
      yield put({ type: types.OPEN_EDIT_USER_DIALOG, open: false });
      yield put({ type: types.OPEN_DELETE_USER_DIALOG, open: false });
    }
  } catch (e) {
    yield resolveError(types.SUBMIT_USER_FAILURE, e);
  } finally {
    yield put({ type: types.SUBMIT_USER_FINISHED });
  }
}

function* watchCheckBranchAccessForUser({ payload }) {
  try {
    yield put({ type: types.START_CHECK_BRANCH_ACCESS_FOR_USER });
    const { jsonData } = yield call(
      usersApi.checkIfUserIsRelatedToBranch,
      payload
    );
    yield put({
      type: types.CHECK_BRANCH_ACCESS_FOR_USER_SUCCESS,
      result: jsonData
    });
  } catch (e) {
    yield resolveError(types.CHECK_BRANCH_ACCESS_FOR_USER_FAILURE, e);
  } finally {
    yield put({ type: types.CHECK_BRANCH_ACCESS_FOR_USER_FINISHED });
  }
}

//This is used to catch all the errors in case of request unsuccessful, and will extract the actual error message.
function* resolveError(type, error) {
  let errorMessageCaptured = false;
  let completeErrorMessage = {};
  if (!error.ok) {
    try {
      const clone = error.clone();
      yield clone.text().then((text) => {
        completeErrorMessage = JSON.parse(text);
        errorMessageCaptured = true;
      });
    } catch (err) {
      errorMessageCaptured = true;
      completeErrorMessage = err;
    }

    if (errorMessageCaptured) {
      const errorMessage = extractErrorMessage(completeErrorMessage);
      yield put({ type, errorMessage });
    }
  }
}

function extractErrorMessage(completeErrorMessage) {
  let errorMessage = '';

  try {
    const message = completeErrorMessage.exceptionMessage
      ? completeErrorMessage.exceptionMessage.split('Content:')[1]
      : completeErrorMessage.messageDetail;

    errorMessage = JSON.parse(message).errorMessage;
    if (!errorMessage) {
      errorMessage = 'An error occured';
    }
  } catch (error) {
    errorMessage = 'An error occured';
  }

  return errorMessage;
}

export default function* branchesWatcher() {
  yield takeLatest(
    types.SEND_CHANGE_PASSWORD_REQUEST,
    watchSendChnagePasswordRequest
  );
  yield takeLatest(types.FETCH_USER_DETAILS, watchFetchUserPermissions);

  yield takeLatest(types.FETCH_ALL_USERS, watchFetchAllUsers);
  yield takeLatest(types.SUBMIT_USER, watchSubmitUser);

  yield takeLatest(
    types.CHECK_BRANCH_ACCESS_FOR_USER,
    watchCheckBranchAccessForUser
  );
}
